<template>
  <span class="text-left">
    <ed-button button-class="btn btn-actionbar"
               @click="showModal(showCloseAccount)"
               :ids="ids"
               :disabled="disabled"
               v-tooltip="tooltip">
      Close Account
    </ed-button>
    <ed-modal title="Close EvedPay Card Account" :show="showCloseAccount" @close="showModal(showCloseAccount), closeObj = {}" @confirm='closeAccount()' primary-button="Confirm">
      <div slot="body" class='close-account-overlay'>
        <p class="small">You are about to close this EvedPay Card Account. Where would you like to move the remaining funds?</p>
        <label>Balance</label>
        <v-money class="small" currency="USD" locale="en">{{balance}}</v-money>
        <ed-radio :options='options' track-by='id' name='add-funding' fieldLabel='Add Funding:' @input="(option) => handleRadioInput(option)">
          <ed-select :options='divisions'
                     @open="getUserDivisions"
                     label='DivisionName'
                     name='divisions'
                     slot="additionalInfo_1"
                     @input="(option) => {this.selectOption.DivisionId = option.DivisionId
                                          this.selectOption.DivisionName = option.DivisionName
                                          this.selectOption.AccountId = option.AccountId} "></ed-select>
          <p slot='additionalInfo_2' class="small">{{division.DivisionName}}</p>
        </ed-radio>
      </div>
    </ed-modal>
  </span>
  
</template>

<script>
import User from '@/core/user'
export default {
  computed: {
    options() {
      return [
        { label: `Transfer to another ${this.divisionName}`, id: '1', status: false, additionalInfo: true, slotName: 'additionalInfo_1' },
        { label: 'Return to customer', id: '2', status: false, additionalInfo: true, slotName: 'additionalInfo_2' }
      ]
    }
  },
  props: {
    balance: {},
    division: {},
    ids: null,
    disabled: false,
    tooltip: ''
  },
  data() {
    return {
      divisions: [],
      divisionName: '',
      selectOption: {},
      selectedValue: {},
      closeObj: {},
      showCloseAccount: false
    }
  },
  created() {
    this.getDivisionNameToSingularWithLowerCase()
  },
  methods: {
    async getUserDivisions() {
      this.divisions = []
      this.api.get(this.api.$.evedpaycard.division)
        .then(response => {
          if (response && response.data) {
            this.divisions = response.data
          }
        })
        .catch(error => {
          console.warn(error)
        })
    },
    getDivisionNameToSingularWithLowerCase() {
      var divisionName = User.get().settings['DivisionName']
      this.divisionName = divisionName[divisionName.length - 1] === 's' ? divisionName.toLowerCase().slice(0, -1) : divisionName
    },
    handleRadioInput(option) {
      this.selectedValue = option.id === '1' && this.selectOption ? this.selectOption : this.division
      this.closeObj = this.selectedValue
      this.closeObj.funds = this.balance
      this.selectedValue = {}
    },
    async closeAccount() {
      if (Object.keys(this.closeObj).length !== 0) {
        const command = {
          SourceAccountId: this.division.AccountId,
          DestinationAccountId: this.closeObj.AccountId,
          Amount: this.balance
        }
        try {
          const response = await this.api.post('/evedpaycards/accounts/transfer-funds', command)
          if (response.status === 200) {
            console.log('Successful transfer!')
            this.$emit('success')
            this.initialAmountError = false
          }
        } catch (error) {
          console.error('Error during the funds transfer:', error)
        }
        this.closeObj = {}
      } else {
        console.log('invalid')
      }
    },
    showModal(showCloseAccount) {
      this.showCloseAccount = !showCloseAccount
    }
  }
}
</script>

<style lang='scss' scoped>
.close-account-overlay {
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/CloseAccount.vue